import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🚀", key: "createSpecial" },
  { emoji: "✨", key: "curious" },
  { emoji: "👀", key: "showExamples" },
]

export default function PetsCommitmentPage() {
  return <RadioCardListPage translationKey="petsCommitment" options={OPTIONS} />
}
